export const htmlComponentMetaData = {
    isRepeatable: false
}
